<template>
    <v-app>
        <v-main>
            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Estimasi Pengeluaran</h3>
                                    <div class="card-tools"></div>
                                </div>
                                <!-- /.card-header -->
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <v-dialog ref="dialog" v-model="modaltgl" :return-value.sync="tanggal_query" persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="tanggal_query"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            label="Bulan Permintaan Perubahan" 
                                                            outlined
                                                            dense 
                                                            return-object 
                                                            class="w-100"
                                                            append-icon="mdi-calendar" 
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="tanggal_query" type="month" scrollable min="2022-08">
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="primary" @click="modaltgl = false">Cancel</v-btn>
                                                        <v-btn text color="primary" @click="ubahTanggalTampil($refs)">OK</v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <v-select
                                                v-model="selectedKantor"
                                                :items="kantorOptions"
                                                label="Kas Kantor"
                                                name="kantor_id"
                                                id="kantor_id"
                                                class="w-100"
                                                :class="{ 'is-invalid': adaeror['kantor_id'] }"
                                                outlined
                                                dense
                                                return-object
                                            ></v-select>
                                            <small v-if="adaeror['kantor_id']" class="text-danger">
                                                {{ adaeror["kantor_id"].join(', ') }}
                                            </small>
                                        </div>
                                        <div class="col-md-3"></div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-12">
                                            <form @submit.prevent="createData()" id="formnya">
                                                <div class="row">
                                                    <div 
                                                        class="col-md-2 d-flex flex-column" 
                                                        v-for="(row, index) in kategori_list" 
                                                        :key="row.id"
                                                    >
                                                        <label class="font-weight-bold mb-1">{{ row.value }}</label>

                                                        <div class="input-group">
                                                            <CurrencyInput 
                                                                ref="inputRef" 
                                                                :id="'form_' + row.id"
                                                                :name="'form_' + row.id"
                                                                class="form-control"
                                                                :value="datas[row.id] ? datas[row.id] : 0"
                                                                required
                                                                :disabled="kunci || datas[row.id]"
                                                                :options="{ currency: 'IDR' }" 
                                                            />
                                                            <div class="input-group-append" :class="!kunci && (datas[row.id] || datas[row.id] == 0) ? '' : 'd-none'">
                                                                <a 
                                                                    class="btn btn-outline-primary" 
                                                                    @click="ajukanPenambahanBudget(row, datas[row.id]) "
                                                                    title="Ajukan Penambahan Budget"
                                                                >
                                                                    <i class="fas fa-plus"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <button 
                                                            type="submit" 
                                                            class="btn btn-primary float-right"
                                                            :disabled="kunci || datas != false"
                                                        >
                                                            Simpan!
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">History Budgeting {{ tanggal_tampil }}</h3>
                                    <div class="card-tools"></div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12 table-responsive p-0">
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%;">No</th>
                                                        <th>Jenis</th>
                                                        <th>Kategori</th>
                                                        <th style="text-align: right;">Jumlah</th>
                                                        <th>Tanggal Dibuat</th>
                                                        <th>Oleh</th>
                                                        <th>Keterangan</th>
                                                        <th style="width: 10%; text-align: center;">Status</th>
                                                        <th style="text-align: center;">Detail Approval</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="(dhistory)" v-for="(row, index) in dhistory"
                                                        :key="row.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ row.kategori_estimasi_permintaan.value }}</td>
                                                        <td>{{ row.kategori_keuangan_estimasi_permintaan.value }}</td>
                                                        <td style="text-align: right;"><strong>{{ row.jumlah | toCurrency }}</strong></td>
                                                        <td>{{ row.created_at | indoDate }}</td>
                                                        <td>{{ row.user_estimasi_permintaan.name }}</td>
                                                        <td>
                                                            {{ row.keterangan }}
                                                        </td>
                                                        <td style="text-align: center;">
                                                            <span class="badge badge-danger" v-if="row.statusnya.includes(2)">Ditolak</span>
                                                            <span class="badge badge-success" v-else-if="row.statusnya.every((val, i, arr) => val === arr[0] && val == 1)">Diterima</span>
                                                            <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                                        </td>
                                                        <td style="text-align: center;">
                                                            <button 
                                                                class="btn btn-xs btn-primary" 
                                                                @click="bukaDetailApprovalModal(row.pejabat_approval_permintaan_estimasi)"
                                                                title="Lihat Detail Approval"
                                                            >
                                                                <i class="fas fa-search text-white"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="(!dhistory)">
                                                        <td colspan="8" class="text-center">
                                                            <h6>Data Kosong</h6>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="modal fade" id="DetailApprovalModal" tabindex="-1" role="dialog"
                aria-labelledby="DetailApprovalModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"> Detail Approval </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closeDetailApprovalModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nama Pejabat</th>
                                        <th style="text-align: center;">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="tampilPejabat" v-for="(row, index) in tampilPejabat">
                                        <td>
                                            {{ row.name }}
                                            <div v-if="row.status == 2" class="col-12 text-red mt-1">
                                                
                                            </div>
                                            <p v-if="row.status == 2" class="text-red"> <strong>ALASAN :</strong> {{ row.keterangan }}</p>
                                        </td>
                                        <td style="text-align: center;">
                                            <span class="badge badge-danger" v-if="row.status == 2">Ditolak</span>
                                            <span class="badge badge-success" v-else-if="row.status == 1">Diterima</span>
                                            <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="2" class="text-center">
                                            <h6>Gagal mengambil data pejabat aproval</h6>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                @click="closeDetailApprovalModal()">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="pengajuanPenambahan" tabindex="-1" role="dialog"
                aria-labelledby="tambahBudgetModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"> Pengajuan Penambahan Budget </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closePenambahanBudget()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="kirimPengajuanPenambahan()" id="formpengajuanPenambahan">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Kategori Pengeluaran</label>
                                            <input v-model="kategori_tambah" type="text" class="form-control" required
                                                disabled />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Tanggal</label>
                                            <input v-model="tanggal_tampil" type="text" class="form-control" required
                                                disabled />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Kas Kantor</label>
                                            <input value="Kantor Pusat" type="text" class="form-control" required
                                                disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Jumlah Lama</label>
                                            <input v-model="jumlah_lama" type="number" @keydown="preventArrow($event)"
                                                class="form-control" required disabled />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Jumlah Ditambahkan</label>
                                            <input v-model="tambahBudget.jumlah" type="number"
                                                @keydown="preventArrow($event)" @change="setTotal()"
                                                class="form-control" required :disabled="kunci" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Total</label>
                                            <input v-model="total" type="number" @keydown="preventArrow($event)"
                                                class="form-control" required disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Keterangan</label>
                                            <textarea v-model="tambahBudget.keterangan" style="resize:none" rows="3"
                                                class="form-control" required :disabled="kunci"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Pejabat Approval</label>
                                            <div class="form-check" v-for="row in pejabat_list">
                                                <input type="checkbox" v-model="tambahBudget.pejabat_approval"
                                                    :id="'ch' + row.id" :value="row.id" :name="'ch' + row.id"
                                                    class="form-check-input">
                                                <label :for="'ch' + row.id" class="form-check-label">
                                                    {{ row.name }}
                                                </label>
                                            </div>
                                            <div v-if="!pejabat_list.length">
                                                <span class="text-red">Gagal Mengambil Pejabat Approval</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <br />
                                Yakin Untuk Mengajukan Permintaan Penambahan Budget?
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                    @click="closePenambahanBudget()">Tidak</button>
                                <button type="submit" class="btn btn-success">Ajukan</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </v-main>
    </v-app>
</template>

<script>
    import CurrencyInput from './CurrencyInput'
    export default {
        components: { CurrencyInput },
        data() {
            return {
                selectedKantor: { text: this.$gate.user?.kantor?.value, value: this.$gate.user?.kantor?.id },
                kantorOptions: [{ text: this.$gate.user?.kantor?.value, value: this.$gate.user?.kantor?.id }],
                // adaeror: {},
                tampilPejabat: '',
                dhistory: [],
                datas: [],
                kategori_list: [],
                pejabat_list: [],
                jumlah_estimasi: [],
                kunci: false,
                form: new Form({
                    jumlah: '',
                    kategori: '',
                    keterangan: '',
                    kantor_id: '',
                    pejabat_approval: [],
                    //tanggal:'',
                }),
                tambahBudget: new Form({
                    jumlah: '',
                    kategori_id: '',
                    kategori_riwayat_id: '2',
                    keterangan: '',
                    kantor_id: '',
                    pejabat_approval: [],
                    //tanggal:'',
                }),
                kategori_tambah: '',
                jumlah_lama: '0',
                total: '0',
                adaeror: [],
                menu: false,
                modaltgl: false,
                //dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                jumlahnya: 0,
                json_fields: {
                    "TANGGAL": {
                        field: "created_at",
                        callback: (value) => {
                            return this.getTanggalIndo(value);
                        },
                    },
                    "NAMA KATEGORI": "kategori_keuangan.value",
                    "KAS KANTOR": "keuangan_kantor.value",
                    "JUMLAH": "jumlah",
                    "KETERANGAN": "keterangan",
                },
            }
        },
        methods: {
            bukaDetailApprovalModal(pejabat) {
                this.tampilPejabat = pejabat;
                $('#DetailApprovalModal').modal('show');
            },

            closeDetailApprovalModal() {
                this.tampilPejabat = '';
                $('#DetailApprovalModal').modal('hide');
            },

            getStatusnya() {
                Object.entries(this.dhistory).forEach(([key, val]) => { this.dhistory[key]['statusnya'] = val.pejabat_approval_permintaan_estimasi.map(elm => elm.status) });
            },

            setTotal() {
                this.total = parseInt(this.jumlah_lama) + parseInt(this.tambahBudget.jumlah);
            },

            closePenambahanBudget() {
                this.tambahBudget.reset();
                $('#pengajuanPenambahan').modal('hide');
            },

            ajukanPenambahanBudget(objekKategori, jumlahLama) {
                
                if (!this.kunci) {
                    this.$Progress.start();
                    this.kategori_tambah = objekKategori.value;
                    this.tambahBudget.kategori_id = objekKategori.id;
                    this.tambahBudget.kantor_id = this.$gate.user?.kantor?.id; //sesuaikan dengan kantor pilihan
                    this.jumlah_lama = jumlahLama;
                    this.total = '0';
                    $('#pengajuanPenambahan').modal('show');
                    this.$Progress.finish();
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Budget Bulan Ini Sudah Dikunci!'
                    });
                }

            },
            countJumlahnya() {
                Object.entries(this.datas).forEach(([key, val]) => { this.jumlahnya += parseFloat(val.jumlah) });
            },

            getBulan(tanggal) {
                var tgltemp = new Date(tanggal);
                var tahun = tgltemp.getFullYear();
                var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                var now = new Date();
                if (
                    (tahun > now.getFullYear()) || (tahun == now.getFullYear() && tgltemp.getMonth() >= now.getMonth())
                ) {
                    this.kunci = false;
                } else {
                    this.kunci = true;
                }

                return (bulan[tgltemp.getMonth()] + " " + tahun);
            },

            ubahTanggalTampil(e) {
                e.dialog.save(this.tanggal_query);
                this.loadData();
            },

            getResults(page = 1) {

                this.$Progress.start();
                axios.get('api/keuangan/pengeluaran?page=' + page).then(({ data }) => (this.datas = data.data));
                this.$Progress.finish();
            },

            loadPejabatApproval() {
                axios.get("api/keuangan/pejabat_list").then(({ data }) => (this.pejabat_list = data.data));
            },

            loadKategori() {
                axios.get("api/keuangan/kategori_list?q=" + escape(2)).then(({ data }) => (this.kategori_list = data.data));
            },

            loadHistory() {
                let tahunpaid = this.tanggal_query.substr(0, 4);
                let bulanpaid = this.tanggal_query.substr(-2, 2);
                axios.get("api/keuangan/estimasiHistory?tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                    if (data.data) {
                        this.dhistory = data.data;
                        this.getStatusnya();
                    } else {
                        this.dhistory = false;
                    }
                });
            },

            loadData() {
                if (this.$gate.isAllowed("is_keuangan")) {
                    this.jumlahnya = 0;
                    let tahunpaid = this.tanggal_query.substr(0, 4);
                    let bulanpaid = this.tanggal_query.substr(-2, 2);
                    axios.get("api/keuangan/estimasi?tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                        if (data.data) {
                            this.datas = data.data;
                        } else {
                            this.datas = false;
                        }
                    });
                    this.tanggal_tampil = this.getBulan(this.tanggal_query);
                    this.loadKategori();
                    this.loadPejabatApproval();
                    this.loadHistory();
                }
            },

            createData() {
                this.$Progress.start();
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Apakah Anda Yakin Untuk Menyimpan Budgeting Bulan Ini?",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Yes!'
                }).then((result) => {
                    if (result.value) {
                        let formData = new FormData();
                        var form = document.getElementById("formnya");
                        var kirimdata = [];

                        for (var i = 0, len = form.length; i < len; i++) {
                            if (form.elements[i].id && form.elements[i].value) {
                                let newarray = {
                                    'kategori_id': form.elements[i].id.replace('form_', ''),
                                    'bulan': this.tanggal_query,
                                    'jumlah': form.elements[i].value,
                                    'kantor_id': this.$gate.user?.kantor?.id,
                                    'kategori_riwayat_id': 1,
                                    'created_by': window.user.id,
                                };
                                kirimdata.push(newarray);
                            }
                        }

                        formData.append('datanya', JSON.stringify(kirimdata));
                        axios.post('api/keuangan/addEstimasiPengeluaran', formData)
                            .then((data) => {
                                if (data.data.success) {

                                    Toast.fire({
                                        icon: 'success',
                                        title: data.data.message
                                    });
                                    this.$Progress.finish();
                                    this.loadData();
                                    this.adaeror = [];
                                } else {
                                    Toast.fire({
                                        icon: 'error',
                                        title: 'Some error occured! Please try again'
                                    });

                                    this.$Progress.fail();
                                }
                            })
                            .catch(e => {
                                this.adaeror = e.response.data.errors;
                                this.$Progress.fail();
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })
                    } else {
                        this.$Progress.fail();
                    }
                })
            },

            kirimPengajuanPenambahan() {
                this.$Progress.start();
                if (this.tambahBudget.pejabat_approval.length > 0) {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "Apakah Anda Yakin Untuk Menyimpan Penambahan Budgeting Bulan Ini?",
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Yes!'
                    }).then((result) => {
                        if (result.value) {
                            let editFormData = new FormData();
                            let dataUpdate = {};
                            dataUpdate = this.tambahBudget;
                            editFormData.append('datanya', JSON.stringify(dataUpdate));
                            axios.post('api/keuangan/addBudgetEstimasiPengeluaran', editFormData)
                                .then((data) => {
                                    if (data.data.success) {

                                        Toast.fire({
                                            icon: 'success',
                                            title: data.data.message
                                        });

                                        this.loadData();
                                        this.closePenambahanBudget();

                                        this.$Progress.finish();
                                        this.adaeror = [];
                                    } else {
                                        Toast.fire({
                                            icon: 'error',
                                            title: 'Some error occured! Please try again'
                                        });

                                        this.$Progress.fail();
                                    }
                                })
                                .catch(e => {
                                    this.adaeror = e.response.data.errors;
                                    this.$Progress.fail();
                                    Toast.fire({
                                        icon: 'error',
                                        title: 'Some error occured! Please try again'
                                    });
                                })
                        } else {
                            this.$Progress.fail();
                        }
                    })
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Pejabat Approval Harus Dipilih'
                    });

                    this.$Progress.fail();
                }
            },

            preventArrow(e) {
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
                if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                    e.preventDefault();
                }
            },
        },

        created() {
            this.$Progress.start();
            this.loadData();
            this.$Progress.finish();
        }
    }
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>